import { type BotRuntimeState, createBotRuntime, runBotDecision } from "./bot-runtime.js";
import type { BotSettings } from "./bot-types.js";
import type { ConflictMatch } from "./match.js";
import type { ConflictConfig } from "./types.js";

export type OnlineBotState = BotRuntimeState;

export function createOnlineBots(
  config: ConflictConfig,
  occupied: ReadonlySet<string>,
): readonly OnlineBotState[] {
  const seed = config.rootSeed ?? "kilnfront-online-bots";
  return config.seats
    .filter((seat) => !occupied.has(seat.id))
    .map((seat) => createBotRuntime(seat.id, seat.bot ?? defaultSettings(), seed));
}

export function runOnlineBots(
  match: ConflictMatch,
  config: ConflictConfig,
  bots: readonly OnlineBotState[],
  now: number,
): readonly OnlineBotState[] {
  return bots.map((bot) => {
    if (bot.nextDecisionAtMs > now || !match.observeAs(bot.seatId).self.alive) return bot;
    return runBotDecision(
      match,
      config.matchId ?? "online-room",
      config.rootSeed ?? "kilnfront-online-bots",
      bot,
    ).state;
  });
}

export function autopilotBot(
  seatId: string,
  config: ConflictConfig,
  nextDecisionAtMs: number,
  sequence: number,
): OnlineBotState {
  return createBotRuntime(
    seatId,
    { personality: "defender", difficulty: "foreman" },
    config.rootSeed ?? "kilnfront-online-bots",
    nextDecisionAtMs,
    sequence,
  );
}

function defaultSettings(): BotSettings {
  return { personality: "seeded-mix", difficulty: "foreman" };
}
